import { getIcon } from '../../helpers/icons';
import Button from '../../components/Field/Button';

export function ArticleButton({ type = "popup", url = "", onClick = () => { }, buttonColor = "buttonPrimary" }) {

	let setIcon = "Play";
	let setLabel = "Play";

	if (["audio", "podcast"].includes(type)) {
		setIcon = "Play";
		setLabel = "Listen";
	}
	else if (["document", "web", "presentation"].includes(type)) {
		setIcon = "Document";
		setLabel = "Read";
	}
	else if (["popup", "more"].includes(type)) {
		setIcon = "Info";
		setLabel = "More info";
	}

	return (
		<Button
			onClick={onClick}
			link={url !== "" ? `/article/${url}` : url}
			color={buttonColor}
			icon={<i className={getIcon(setIcon)}></i>}
			label={setLabel}
		/>
	)
}

export const fullScreenHandler = (state, ele) => {
	if (state === true) {
		if (ele.webkitEnterFullScreen)
			ele.webkitEnterFullScreen();
		else if (ele.webkitRequestFullScreen)
			ele.webkitRequestFullScreen();
		else if (ele.requestFullscreen)
			ele.requestFullscreen();
		else if (ele.mozRequestFullScreen)
			ele.mozRequestFullScreen();
	}
	else {
		if (document.webkitExitFullscreen)
			document.webkitExitFullscreen();
		else if (document.webkitCancelFullScreen)
			document.webkitCancelFullScreen();
		else if (document.exitFullscreen)
			document.exitFullscreen();
		else if (document.mozCancelFullScreen)
			document.mozCancelFullScreen();
	}
}